import { documentActionTypes as actionType } from 'src/constants/actionTypes';
import documentService from 'src/services/documentService';
import dispatchError from 'src/utils/dispatchError';
import { startAction, stopAction } from './uiActions';

export function searchDocuments(data) {
  return async (dispatch) => {
    try {
      dispatch(startAction());
      const documents = await documentService.searchDocuments(data);
      dispatch({
        type: actionType.SEARCH_SUCCESS,
        payload: {
          documents
        }
      });
    } catch (error) {
      dispatchError(
        dispatch,
        error,
        actionType.FAILURE,
        'Failed to get list of documents'
      );
    } finally {
      dispatch(stopAction());
    }
  };
}

export function exportDocuments(data, isChecked) {
  return async (dispatch) => {
    try {
      dispatch(startAction());
      let response;
      if (isChecked) {
        response = await documentService.exportSelectedDocuments(data);
      } else {
        response = await documentService.exportDocuments(data);
      }
      const file = new Blob(
        [response.blob],
        { type: 'application/octet-stream' }
      );

      const fileURL = URL.createObjectURL(file);
      const filename = 'SearchReport.csv';

      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display:none';
      a.href = fileURL;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(fileURL);
      a.remove();
      dispatch({ type: actionType.SUCCESS });
    } catch (error) {
      dispatchError(dispatch, error, actionType.FAILURE, 'Failed to export search report');
    } finally {
      dispatch(stopAction());
    }
  };
}

export function getDocumentDetails(docId) {
  return async (dispatch) => {
    try {
      const document = await documentService.getDocumentDetails(docId);
      dispatch({
        type: actionType.GET_SUCCESS,
        payload: {
          document
        }
      });
    } catch (error) {
      dispatchError(
        dispatch,
        error,
        actionType.FAILURE,
        'Failed to get document details'
      );
    }
  };
}

export function getDocumentFile(docId) {
  return async (dispatch) => {
    try {
      const data = await documentService.getDocumentFile(docId);
      const filename = data.filename.replace(/["]+/g, '');
      const document = await documentService.getDocumentDetails(docId);

      const file = new Blob([data.blob], { type: data.blob.type });
      const fileURL = URL.createObjectURL(file);

      dispatch({
        type: actionType.GET_FILE_SUCCESS,
        payload: {
          document,
          blob: fileURL,
          filename
        }
      });
    } catch (error) {
      dispatchError(
        dispatch,
        error,
        actionType.FAILURE,
        'Failed to get document file'
      );
    }
  };
}

export function downloadDocument(docId, nameOfFile, pwd) {
  return async (dispatch) => {
    try {
      const data = await documentService.getDocumentContent(docId, pwd);
      dispatch({
        type: actionType.DOWNLOAD_SUCCESS,
        payload: {
          successMessage: 'Download successful'
        }
      });
      const file = new Blob([data.blob], { type: data.blob.type });
      const fileURL = URL.createObjectURL(file);

      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display:none';
      a.href = fileURL;
      a.download = data.filename.replace(/['"]+/g, '');
      if (nameOfFile) {
        a.download = nameOfFile;
      }
      a.click();
      window.URL.revokeObjectURL(fileURL);
      a.remove();
    } catch (error) {
      dispatchError(
        dispatch,
        error,
        actionType.FAILURE,
        'Failed to download documents'
      );
    }
  };
}

export function downloadDocuments(isZip, docIdArray, nameOfFile, pwd) {
  return async (dispatch) => {
    try {
      let data;
      if (isZip) {
        data = await documentService.getDocumentsZip(docIdArray);
      } else {
        data = await documentService.getDocumentsPdf(docIdArray, pwd);
      }
      dispatch({
        type: actionType.DOWNLOAD_SUCCESS,
        payload: {
          successMessage: 'Download successful'
        }
      });
      const file = new Blob([data.blob], { type: data.blob.type });
      const fileURL = URL.createObjectURL(file);

      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display:none';
      a.href = fileURL;
      a.download = data.filename.replace(/['"]+/g, '');
      if (nameOfFile) {
        a.download = nameOfFile;
      }
      a.click();
      window.URL.revokeObjectURL(fileURL);
      a.remove();
    } catch (error) {
      dispatchError(
        dispatch,
        error,
        actionType.FAILURE,
        'Failed to download documents'
      );
    }
  };
}

export function uploadDocuments(documents) {
  return async (dispatch) => {
    try {
      const results = [];
      documents.forEach((document) => results.push(documentService.uploadDocuments(document)));
      await Promise.all(results);

      dispatch({
        type: actionType.UPLOAD_SUCCESS,
        payload: {
          successMessage: `${documents.length} documents uploaded.`
        }
      });
    } catch (error) {
      dispatchError(
        dispatch,
        error,
        actionType.FAILURE,
        'Failed to upload documents'
      );
    }
  };
}

export function updateDocument(editFields, docId) {
  return async (dispatch) => {
    try {
      const document = await documentService.updateDocument(editFields, docId);
      dispatch({
        type: actionType.UPDATE_SUCCESS,
        payload: {
          document
        }
      });
    } catch (error) {
      dispatchError(
        dispatch,
        error,
        actionType.FAILURE,
        'Failed to update document'
      );
    }
  };
}

export function emailDocuments(data) {
  return async (dispatch) => {
    try {
      await documentService.emailDocuments(data);
      dispatch({
        type: actionType.EMAIL_SUCCESS,
        payload: {
          successMessage: 'Email sent'
        }
      });
    } catch (error) {
      dispatchError(
        dispatch,
        error,
        actionType.FAILURE,
        'Failed to email documents'
      );
    }
  };
}

export const clearDocuments = () => ({ type: actionType.CLEAR_LIST });
export const clearSelectedDocument = () => ({
  type: actionType.CLEAR_SELECTED
});
export const clearMessages = () => ({ type: actionType.CLEAR_MESSAGES });
